<template>
  <van-popup
      class="jd-sku-select-con"
      v-model="show"
      closeable
      close-icon="close"
      position="bottom"
      :style="{ height: '80%' }"
      @close="onClose"
  >
    <div class="header-con">
      <div class="img-con">
        <img class="img" :src="'http://img13.360buyimg.com/n1/' + currentDetail.noneBookVO.imagePath" alt="" @click="lookPic">
      </div>
      <div class="title-con">
        <div class="price" v-if="currentPrice.sellPrice">￥ <span class="big">{{ price[0] }}</span><span>.{{ price[1] }}</span></div>
        <div class="price" v-if="!currentPrice.sellPrice">暂无定价</div>
        <div class="sku-number">编号:{{ currentSku }}</div>
      </div>
    </div>
    <div class="select-con">
      <div class="specs-con" v-for="(data, index) in skusList" :key="index">
        <div class="specs-name">{{ data.saleName }}</div>
        <div class="specs-val-con">
          <div class="specs-val"
               v-for="(item, i) in data.saleAttrList" :key="i"
               :data-skus="item.skuIds"
               :class="{active: (data.selected===i), disable: item.disable}"
               @click="checkOne(index, i, item)"
          >{{ item.saleValue }}</div>
        </div>
      </div>
      <div class="num-con">
        <div class="num-con-name">数量</div>
        <div class="stepper-con">
          <van-stepper
              name="buyNum"
              v-model="buyNum"
              integer
              min="1"
              max="200"
              input-width="44"
              button-size="22"
              :disabled="false"
              :disable-input="false"
              @change="buyNumChange"
          />
        </div>
      </div>
    </div>
    <div class="is-area-restrict" v-if="currentIsAreaRestrict">该商品在该地区暂时不支持销售，非常抱歉</div>
    <div class="bottom-com">
      <div class="btn-con" v-if="isHasSku && currentPrice.sellPrice && currentSkuStock!==34 && currentSkuStock!==36 && currentSalesCheck.saleState===1 && currentUpDownStatus===1 && !currentIsAreaRestrict">
        <div class="btn add-to-cart" v-if="skuShowType===1" @click="addCart">加入购物车</div>
        <div class="btn buy-at-once" v-if="skuShowType===2" @click="buyGoods">立即购买</div>

        <div class="btn add-to-cart" style="margin-right: 12px;" v-if="skuShowType===99" @click="addCart">加入购物车</div>
        <div class="btn buy-at-once" v-if="skuShowType===99" @click="buyGoods">立即购买</div>
      </div>
      <div class="btn-con no-goods" v-else>
        <div class="btn add-to-cart" style="margin-right: 12px;">加入购物车</div>
        <div class="btn buy-at-once">无货</div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { listProducts } from '@/api/mall/mallGoods'
import { listShops } from '@/api/mall/mallShop'
import { mapGetters } from 'vuex'
export default {
  components: {
  },
  computed:{
    ...mapGetters([
      'currentSku',//当前sku
      'currentProductId',//当前sku的货品ID
      'currentBuyNum',//当前商品购买数量
      'goodsDetails',//所有sku的详情
      'skusImgs',//所有sku的所有图片
      'currentPrice',//当前sku价格
      'currentSkuStock',//是否有库存
      'skus',//同类商品sku
      'jdSkuShow',
      'shopDetail',//店铺详情
      'currentSalesCheck',//当前商品是否可售校验
      'currentUpDownStatus',//当前商品上下架状态
      'currentIsAreaRestrict',//当前商品当前地区是否限制购买
    ])
  },
  watch:{
    skus(skus){
      this.skusList = skus
      this.initFirstClick()
    },
    jdSkuShow(val){
      this.show = val
      this.skuShowType = this.session('skuShowType')
    },
    currentBuyNum(val){
      console.log('watch-currentBuyNum',val)
      this.buyNum = val
    },
    currentPrice(data){
      this.price = data.sellPrice ? data.sellPrice.toFixed(2).split('.') : ['0','00']
    },
    goodsDetails(data){
      this.currentDetail = data[this.currentSku]
    },
    currentIsAreaRestrict(val){
      console.log('currentIsAreaRestrict', val)
    },
  },
  data(){
    return {
      first: 1,//是否首次进入页面
      show: false,
      buyNum: 1,
      price: ['0', '00'],
      currentDetail: {noneBookVO: {}},
      skusList: [],
      isHasSku: true,
      skuShowType: 1,
    }
  },
  created(){

  },
  methods: {
    onClose(){
      this.$store.commit('sg/change_skuShow', false)
    },
    // 初始化第一进入页面
    initFirstClick(){
      if(this.first===1 && this.skus.length>0){
        this.first++
        this.checkOne(0, this.skus[0].selected, this.skus[0].saleAttrList[this.skus[0].selected])
      }else {
        return false
      }
    },

    //  点击时
    checkOne(index, i, item){
      console.log(index, i, item)// 第 n 栏， 第 m 个， ids
      // if(item.disable){
      //   return false
      // }
      let skuIds = item.skuIds
      let selectText = ''
      let skus = Object.assign([], this.skus)
      if(this.skusList[index].saleAttrList.length>1){
        skus[index]['selected'] = i
      }

      let baseIndexs = []
      skus.forEach((item, i)=>{
        if(index!==i){
          baseIndexs.push(i)
        }
        selectText += (item.saleAttrList[item.selected].saleValue + ', ')
      })
      // console.log('baseIndexs', baseIndexs)

      let allSelect = baseIndexs.map(m=>{
        let o = []
        baseIndexs.forEach((n, n1)=>{
          if(m!==n){
            o.push( Object.assign([], skus[n].saleAttrList[skus[n].selected].skuIds) )
          }
        })
        o.unshift(skuIds)
        // console.log('o', o)
        skus[m].saleAttrList.forEach((item, i)=>{
          let i_o = Object.assign([], o)
          i_o.push(item.skuIds)
          // console.log(i, item.saleValue, i_o)
          let re = (this.arrsSum(i_o) || [])
          // console.log('re', re)
          if(re.length>0){
            skus[m].saleAttrList[i].disable = false
          }else {
            skus[m].saleAttrList[i].disable = true
          }
        })
        return Object.assign([], skus[m].saleAttrList[skus[m].selected].skuIds)
      })
      this.$store.commit('sg/commitSuks', skus)
      // 当前选中sku
      allSelect.unshift(skuIds)
      let activeSku = this.arrsSum( allSelect )
      console.log('activeSku', activeSku)

      if(activeSku){
        this.isHasSku = true
        this.$store.dispatch('sg/change_currentSku', activeSku[0])
        this.$store.commit('sg/change_currentsSelectText', (selectText + this.currentBuyNum +  '个'))
        // this.$store.dispatch('sg/getJDQueryFreight', [{skuId: activeSku[0], num: this.currentBuyNum}])
        // this.$store.dispatch('sg/getJDGoodsStock', {skuNums:[{skuId: this.currentSku, num: this.currentBuyNum}]})
        if(skus.length>2 && (this.first===2) ){// 处理 第一栏不可选中
          this.first++
          this.checkOne(1, this.skus[1].selected, this.skus[1].saleAttrList[this.skus[1].selected])
        }
      }else {
        this.isHasSku = false
        this.$toast('该属性组合不存在，请重新选择')
      }
    },
    // 获取 n 个数组的交集
    arrsSum(arrays){ // [ [], [], [] ]
      var arrs = arrays.map(item=>{
        return (Object.assign([], item))
      })
      // console.log('arrs', arrs)
      var arr = arrs.shift();
      for(var i=arrs.length;i--;){
        var p = {"boolean":{}, "number":{}, "string":{}}, obj = [];
        arr = arr.concat(arrs[i]).filter(function (x) {
          var t = typeof x;
          return !((t in p) ? !p[t][x] && (p[t][x] = 1) : obj.indexOf(x) < 0 && obj.push(x));
        });
        if(!arr.length) return null;
      }
      return arr;
    },
    // 数量发生改变时
    buyNumChange(value, detail){
      if(typeof value==='number'){
        this.$store.dispatch('sg/change_currentBuyNum', value)
      }
    },
    //添加至购物车
    addCart(){
      let goodsId = this.goodsDetails[this.currentSku].goodsId
      let shopId = this.shopDetail.shopId
      let inviteUserId = this.$route.query.inviteUserId

      let req = {
        items: [
          {
            goodsId: this.goodsDetails[this.currentSku].goodsId,
            goodsType: this.goodsDetails[this.currentSku].goodsType,
            priceWhenAdded: this.currentPrice.sellPrice,
            productCode: this.goodsDetails[this.currentSku].sku,
            productCount: this.currentBuyNum,
            productId: this.goodsDetails[this.currentSku].productId,
            shopId: this.shopDetail.shopId,
            shopSysType: this.shopDetail.shopSysType
          }
        ]
      }
      if(inviteUserId){//是否有分享人
        req.items[0].inviteUserId = inviteUserId
        // let inviteBuyData = this.session('inviteBuyData') ? this.session('inviteBuyData') : {}
        // inviteBuyData[shopId+'_'+goodsId] = inviteUserId
        // this.session('inviteBuyData', inviteBuyData)
      }

      this.$store.dispatch('sg/addBuyCart', req)
    },
    buyGoods(){
      let goodsId = this.goodsDetails[this.currentSku].goodsId
      let shopId = this.shopDetail.shopId
      let inviteUserId = this.$route.query.inviteUserId
      if(inviteUserId){//是否有分享人
        let inviteBuyData = this.session('inviteBuyData') ? this.session('inviteBuyData') : {}
        inviteBuyData[shopId+'_'+goodsId] = inviteUserId
        this.session('inviteBuyData', inviteBuyData)
      }
      // 下单数据
      let obj = {
        shopId,
        shopSysType: '',
        mapShopInfo: {},
        shopItems: [],
      }


      this.getShopDetail({shopIds: [shopId]}).then(res=>{
        return new Promise((resolve, reject) => {
          obj.mapShopInfo = res.data[shopId]
          resolve()
        })
      }).then(
        this.getGoodsDetail({productIds: [this.currentProductId]}).then(res=>{
          let goods = {
            goodsId: this.goodsDetails[this.currentSku].goodsId,
            goodsType: this.goodsDetails[this.currentSku].goodsType,
            productCode: this.goodsDetails[this.currentSku].sku,
            productCount: this.currentBuyNum,
            productId: this.goodsDetails[this.currentSku].productId,
          }
          goods.mapProductDetail = res.data[this.currentProductId]
          obj.shopItems = [goods]

          console.log(obj)
          localStorage.setItem('sgOrderGoodsList', JSON.stringify([obj]))
          this.$router.push({name: 'sgConfirmOrder'})
        })
      )
    },

    //获取商品信息
    getGoodsDetail(req){
      return new Promise((resolve, reject) => {
        listProducts(req).then(res=>{
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    //获取店铺信息
    getShopDetail(req){
      return new Promise((resolve, reject) => {
        listShops(req).then(res=>{
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    //查看大图
    lookPic(){
      this.$store.commit('sg/pictureLook', 0)
    },
  }
}
</script>

<style lang="less" scoped>
.jd-sku-select-con{
  .header-con{
    padding: 12px;
    display: flex;
    .img-con{
      display: inline-flex;justify-content: center;align-items: center;
      .img{
        width: 100px;height: 100px;
      }
    }
    .title-con{
      flex: 1;display: flex;flex-direction: column;
      justify-content: flex-end;padding: 0 0 0 10px;
      .price{
        color: #f0250f;font-size: 11px;font-weight: bold;
        .big{font-size: 18px;}
      }
      .sku-number{
        font-size: 11px;color: #999;
      }
    }
  }
  .select-con{
    position: absolute;z-index: 0;left: 0;right: 0;top: 124px;bottom: 50px;
    overflow-y: auto;padding-bottom: 20px;
    .specs-con{
      font-size: 14px;color: #333;
      .specs-name{
        line-height: 1;font-weight: bold;padding: 12px;
      }
      .specs-val-con{
        display: flex;flex-wrap: wrap;padding: 8px 12px 0;
        .specs-val{
          line-height: 1;padding: 8px 12px;border-radius: 14px;
          display: inline-flex;flex-grow:0;flex-shrink:0;margin: 0 15px 12px 0;
          background-color: #f2f2f2;border: 1px solid #f2f2f2;color: #333;
          &.active{
            background-color: #fff;border-color: #1585f3;color: #1585f3;
          }
          &.disable{
            text-decoration: line-through;
            background-color: #f2f2f2;border: 1px solid #f2f2f2;color: rgba(51,51,51,.5);
          }
        }
      }
    }
    .num-con{
      display: flex;font-size: 14px;color: #333;
      .num-con-name{
        display: inline-flex;justify-content: center;align-items: center;
        line-height: 1;font-weight: bold;padding: 12px;
      }
      .stepper-con{
        flex: 1;padding-right: 12px;
        display: inline-flex;justify-content: flex-end;align-items: center;
      }
    }
  }
  .is-area-restrict{
    height: 20px;position: fixed;left: 0;right: 0;bottom: 50px;
    display: flex;justify-content: center;align-items: center;
    font-size: 10px;color: #f74646;background-color: #ffdfdf;
  }
  .bottom-com{
    padding: 5px 12px;position: absolute;
    left: 0;right: 0;bottom: 0;
    display: flex;
    .btn-con{
      flex: 1;display: inline-flex;justify-content: space-evenly;align-items: center;
      .btn{
        flex: 1;
        color: #fff;border-radius: 20px;
        font-size: 16px;font-weight: bold;
        text-align: center;line-height: 40px;
        &.add-to-cart{background-color: #1585f3;}
        &.buy-at-once{background-color: #f74646;}
      }
      &.no-goods{
        .add-to-cart{background-color: rgba(21, 133, 243, 0.5);}
        .buy-at-once{background-color: rgba(247, 70, 70, 0.5);}
      }

    }
  }
}
</style>